import { toast } from 'react-toastify';

const defaultOptions = {
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
};

export const showSuccess = (message) => toast.success(
  message || 'Operation completed successfully.',
  defaultOptions
);

export const showError = (message) => toast.error(
  message || 'Something went wrong. Please try again.',
  { ...defaultOptions, autoClose: 5000 }
);

export const showWarning = (message) => toast.warning(
  message || 'Please review and try again.',
  { ...defaultOptions, autoClose: 4500 }
);

export const showInfo = (message) => toast.info(
  message || 'Action canceled.',
  defaultOptions
);
